import axios from "axios";
import { enqueueSnackbar, useSnackbar } from "notistack";

// Action types
const SET_USER = "SET_USER";
const CLEAR_USER = "CLEAR_USER";
const LIKE_PRODUCT = "LIKE_PRODUCT";
const UNLIKE_PRODUCT = "UNLIKE_PRODUCT";
const SET_LIKED_PRODUCTS = "SET_LIKED_PRODUCTS";

// Initial state
const initialState = {
  user: {
    email: "",
    token: "",
    likedProducts: [],
    isLoggedIn: false,
  },
};

// Selectors
export const isProductLiked = (userState, productId) => {
  if (!userState?.likedProducts?.length || !productId) {
    return false;
  }
  return userState.likedProducts?.some((p) => p?.product?.upc === productId);
};

// Reducer
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        user: {
          email: action.payload?.email ?? "",
          token: action.payload?.token ?? "",
          likedProducts: action.payload?.likedProducts ?? [],
          isLoggedIn: true,
        },
      };
    case CLEAR_USER:
      return {
        ...state,
        user: {
          email: "",
          token: "",
          likedProducts: [],
          isLoggedIn: false,
        },
      };
    case LIKE_PRODUCT:
      return {
        ...state,
        user: {
          ...state.user,
          likedProducts: [...state.user.likedProducts, action.payload],
        },
      };
    case UNLIKE_PRODUCT:
      return {
        ...state,
        user: {
          ...state.user,
          likedProducts: state.user.likedProducts.filter(
            (product) => product.upc !== action.payload.id
          ),
        },
      };
    case SET_LIKED_PRODUCTS:
      return {
        ...state,
        user: {
          ...state.user,
          likedProducts: Array.isArray(action.payload) ? action.payload : [],
        },
      };

    default:
      return state;
  }
};

export const likeProduct = (product) => {
  return async (dispatch, getState) => {
    const { user } = getState().user;
    try {
      const response = await axios.post("/like_product", {
        upc: product,
        token: user.token,
      });
      if (response.status === 200) {
        dispatch({
          type: LIKE_PRODUCT,
          payload: product,
        });
      }
    } catch (error) {
      console.error("Error liking product:", error);
    }
  };
};

export const unlikeProduct = (id) => {
  return async (dispatch, getState) => {
    const { user } = getState().user;
    try {
      const response = await axios.post("/unlike_product", {
        upc: id,
        token: user.token,
      });
      if (response.status === 200) {
        dispatch({
          type: UNLIKE_PRODUCT,
          payload: id,
        });
      }
    } catch (error) {
      console.error("Error unliking product:", error);
    }
  };
};

export const fetchLikedProducts = () => {
  return async (dispatch, getState) => {
    const { user } = getState().user;
    if (!user.token) return;
    try {
      const response = await axios.post("/get_favorites", {
        token: user.token,
      });
      console.log("Fetched liked products:", response.data);
      if (response.status === 201) {
        dispatch({
          type: SET_LIKED_PRODUCTS,
          payload: Array.isArray(response.data) ? response.data : [],
        });
      }
    } catch (error) {
      console.error("Error fetching liked products:", error);
    }
  };
};

export const setUser = (userInfo) => ({
  type: SET_USER,
  payload: userInfo,
});

export const clearUser = () => ({
  type: CLEAR_USER,
});

export default userReducer;
